<template lang="pug">
.app-exclusive
  Product(:product-id="productId" v-if="!error" @loadError="error = true")
  err404(v-if="error")
</template>
<script setup lang="ts">
import { computed, defineAsyncComponent, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useRogue } from '@/js/services/Rogue'

const Product = defineAsyncComponent(() => import(/* webpackChunkName: "pf-product" */ '../product/product.vue'))

const rogue = useRogue()
const route = useRoute()

const error = ref<boolean>(false)

const productId = computed<number>(() => !rogue.appContext ? -1 : parseInt(route.params.productId as string, 10))
</script>

<style scoped lang="scss">
</style>
